export default __webpack_public_path__ + "static/pro_Strategy-21548c027b4068496c10690d232d389e.png";